import { StyleSheet } from 'react-native';
import { SIZES, PALETTE, MQ_TABLET} from '../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";
import ResponsiveDimensionValues from '../../components/common/responsive-dimension-values';
let windowWidth = ResponsiveDimensionValues.windowWidth;

export default MediaQueryStyleSheet.create({
  mainWrapper:{
    flex:1,
  },
  headerNotes: {
    paddingVertical: 15,
    paddingHorizontal: 10,
  },
  row: {
    flex: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  rowLogout: {
    flex: 0,
    flexDirection: 'row',
    alignItems: 'center',
  },
  rowTouchId: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
  },
  separator:{

  },
  profilePadd: {
   paddingVertical: 0,
   alignItems: 'center',
  },  
  icon: {
    flex: 0.1,
    alignSelf: 'center'
  },
  labelText: {
    flex: 0.9,
  },
  paddRgt: {
    paddingRight: 10
  },
  subLabel: {
    color: PALETTE.primaryStrokeLine
  },
   rowStyle:{
      flex:1,
      flexDirection: 'row',
      marginTop:20,
      marginBottom:15,
      backgroundColor: 'transparent',
      // justifyContent: 'space-between',
      paddingLeft: 1,
      paddingRight: 2,
      marginLeft:80,
      marginRight:1,
    },
    checkboxStyle: {
        height: 26,
        width:26
    },
    logoutText: {
      paddingTop: 10
    },
},{
  [MQ_TABLET]: {
    mainWrapper:{
    width:windowWidth*0.6,
    alignSelf:'center',
    borderWidth: 2,
    borderColor: PALETTE.primaryStrokeLine,
    marginTop:50,
  },
  headerNotes: {
    alignSelf:'center',
     
  },
  separator:{
    width:windowWidth*0.6-30,
    borderBottomWidth: 1,
     borderColor: PALETTE.primaryStrokeLine,
     alignSelf:'center',
     marginLeft:25,
     marginRight:20,
  },
  icon: {
    flex: 0.08,
  },
  labelText: {
    flex: 0.92
  },
   rowStyle:{
      flex:1,
      flexDirection: 'row',
      marginTop:20,
      marginBottom:15,
      backgroundColor: 'transparent',
      // justifyContent: 'space-between',
      paddingLeft: 30,
      paddingRight: 30,
      marginLeft:140,
      marginRight:1,
    }, 

  }
});
